import { useChatStore } from '../../store/chatStore';
import { BookOpen, Wrench, HelpCircle, FileSearch } from 'lucide-react';

const suggestedTopics = [
  {
    icon: BookOpen,
    title: 'Getting Started',
    description: 'Learn the basics of the system',
  },
  {
    icon: Wrench,
    title: 'Troubleshooting',
    description: 'Find solutions to common issues',
  },
  {
    icon: HelpCircle,
    title: 'Features',
    description: 'Explore available features',
  },
  {
    icon: FileSearch,
    title: 'Documentation',
    description: 'Access user manuals and guides',
  },
];

export function WelcomeScreen() {
  const { persona, setSuggestedInput } = useChatStore();

  const handleTopicClick = (title: string) => {
    // Populate the input field with a prompt based on the topic
    setSuggestedInput(`Help me with ${title.toLowerCase()}`);
  };

  return (
    <div className="h-full flex flex-col items-center justify-center p-8">
      <div className="max-w-2xl w-full text-center">
        {/* Logo/Title */}
        <div className="mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-primary-100 mb-4">
            <BookOpen className="w-8 h-8 text-primary-600" />
          </div>
          <h1 className="text-2xl font-semibold text-gray-800 mb-2">
            Welcome to LISA
          </h1>
          <p className="text-gray-500">
            Ask me anything about your documentation. I'll help you find answers with source citations.
          </p>
        </div>

        {/* Persona indicator */}
        <div className="mb-8">
          <span className="inline-flex items-center px-3 py-1 rounded-full text-sm bg-gray-100 text-gray-600">
            Currently viewing as: <span className="font-medium ml-1 capitalize">{persona}</span>
          </span>
        </div>

        {/* Topic suggestions - clicking populates input, does not auto-send */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          {suggestedTopics.map((item) => (
            <button
              key={item.title}
              onClick={() => handleTopicClick(item.title)}
              className="flex items-start gap-3 p-4 rounded-xl border border-gray-200 hover:border-primary-300 hover:bg-primary-50 transition-all text-left group"
            >
              <div className="p-2 rounded-lg bg-gray-100 group-hover:bg-primary-100 transition-colors">
                <item.icon className="w-5 h-5 text-gray-600 group-hover:text-primary-600" />
              </div>
              <div>
                <h3 className="font-medium text-gray-800 text-sm">{item.title}</h3>
                <p className="text-gray-500 text-sm mt-0.5">{item.description}</p>
              </div>
            </button>
          ))}
        </div>

        {/* Capabilities note */}
        <div className="mt-8 text-sm text-gray-400">
          <p>I can search documentation, provide step-by-step guides, and cite my sources.</p>
        </div>
      </div>
    </div>
  );
}
